/**
 * Resolve a non-empty alt string for CMS images.
 * Decorative images may pass decorative: true to allow empty alt.
 */
export function resolveImageAlt(
  alt: string | null | undefined,
  fallback: string | null | undefined,
  options?: { decorative?: boolean },
): string {
  if (options?.decorative) return "";
  const primary = String(alt ?? "").trim();
  if (primary) return primary;
  const secondary = String(fallback ?? "").trim();
  if (secondary) return secondary;
  return "Mont Blanc Treks";
}
